import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=2f8134fd&scoped=true&"
import script from "./userList.vue?vue&type=script&lang=js&"
export * from "./userList.vue?vue&type=script&lang=js&"
import style0 from "./userList.vue?vue&type=style&index=0&id=2f8134fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8134fd",
  null
  
)

export default component.exports